import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (hideHeader) => {
  if (hideHeader) {
    return {
      borderRadius: 0,
      border: 'none',
    };
  }
  return {};
};

export const headerWrapper: SxStyleFunc<boolean | undefined> = (isPeople) => ({
  background: isPeople ? 'none' : (p) => p.palette.primary[50],
});

export const content: SxStyle = {
  gap: (p) => p.spacing(1),
  padding: 0,
};

export const header: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
  color: (p) => p.palette.primary[600],
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: (p) => p.spacing(1.5, 2),
};

export const column: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};

export const titleRow: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};

export const latestFundingCard: SxStyle = {
  background: (p) => p.palette.grey[100],
  borderRadius: (p) => p.spacing(1),
  margin: (p) => p.spacing(1),
  marginTop: (p) => p.spacing(0),
};

export const latestFunctinDate: SxStyle = {
  display: 'inline',
  fontSize: (p) => p.typography.caption,
  fontWeight: 400,
};
